import React, { useState } from "react";
import { Grid, Tabs, Tab } from "@material-ui/core";
import ValetInventory from "../ValetInventory";
import { useStyles } from "./ValetInventoryView.styles";
import clsx from "clsx";
import FolderOutlinedIcon from '@material-ui/icons/FolderOutlined';
import DriveEtaOutlinedIcon from '@material-ui/icons/DriveEtaOutlined';
import useHasPermissions from "../../../hooks/useHasPermissions";
import ValetInventoryHistory from '../ValetInventoryHistory/ValetInventoryHistory';


const ValetInventoryView = () => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState("current");

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const { hasPermissions } = useHasPermissions();
  const historicaltabViewpermission = hasPermissions([
    "historicaltab.view"
  ]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Tabs
          value={selectedTab}
          className={clsx(classes.currentTab)}
          onChange={handleTabChange}
          variant="fullWidth"
          centered
          style={{ width: "100%" }}
        >
          <Tab value="current"
            label="Current"
            icon={<DriveEtaOutlinedIcon />}
          />
          {historicaltabViewpermission && (
            <Tab value="historical"
              label="Historical"
              icon={<FolderOutlinedIcon />}
            />
          )}
        </Tabs>
      </Grid>

      <Grid item xs={12}>
        {selectedTab === "current" && (
          <ValetInventory />
        )}

        {selectedTab === "historical" && (
          <ValetInventoryHistory />
        )}
      </Grid>
    </Grid>
  );
};

export default ValetInventoryView;
